import { Checkbox, Text } from "@mantine/core";

interface TaxProConfirmationProps {
  isTaxProConfirmed: boolean;
  onConfirmationChange: (confirmed: boolean) => void;
}

export const TaxProConfirmation = ({
  isTaxProConfirmed,
  onConfirmationChange,
}: TaxProConfirmationProps) => {
  return (
    <Checkbox
      label={
        <Text fz={12} fw={500}>
          I confirm that I am a Tax Professional
        </Text>
      }
      checked={isTaxProConfirmed}
      onChange={(event) => onConfirmationChange(event.currentTarget.checked)}
    />
  );
};
